module.exports = __webpack_public_path__ + "img/plate_photo_8.78e9ff12.jpg";